import React from 'react';
import { useContext } from 'react';
import alertContext from '../../context/alert/AlertContext';

function Alert() {
  const AlertContext = useContext(alertContext);
  const { alert } = AlertContext;
  // console.log(alert);
  return (
    alert !== null && (
      <>
        <div className={`alert alert-${alert.type}`}>
          <i className='fas fa-info-circle' /> {alert.msg}
          {/* <i className='fa-solid fa-comment-exclamation'> {alert.msg}</i> */}
        </div>
      </>
    )
  );
}

export default Alert;
